import React, { useState } from 'react';
import { useTranslate } from '@im/react-localization';
import { useSimpleSearchBusinessTypesLookUp } from 'src/hooks/simpleSearchHook';
import { useNavigate } from 'react-router';
import SearchBarComp from 'src/components/SearchBar/SearchBar';
import debounce from '@mui/material/utils/debounce';
import { useSearchParams } from 'react-router-dom';

const DEBOUCE_DELAY = 500;
export default function DealSearchBar() {
  const translate = useTranslate();
  const [inputValue, setInputValue] = useState<string>('');
  const navigate = useNavigate();
  const onInputChange = (value: string) => {
    setInputValue(value);
  };
  const [searchParams] = useSearchParams();
  const countryCode = searchParams.get('countryCode');
  const companyCode = searchParams.get('companyCode');
  const businessType = searchParams.get('businessType');
  const { data } = useSimpleSearchBusinessTypesLookUp({
    businessType: businessType,
    countryCode: countryCode ?? '',
    dealNameToSearch: inputValue.trim(),
  });
  const options = data ?? [];

  const onOptionSelected = (value: string) => {
    navigate(
      `/vendor-program/search-results?${
        businessType === 'Subscription' ? `businessType=${businessType}&` : ''
      }dealNumber=${encodeURIComponent(
        value.trim()
      )}&countryCode=${countryCode}&companyCode=${companyCode}`
    );
  };
  return (
    <SearchBarComp
      autoCompleteDataTestId="gds-searchResult-searchBar"
      exception={false}
      onInputChange={debounce(onInputChange, DEBOUCE_DELAY)}
      onOptionSelected={onOptionSelected}
      options={options.map((o) => o.deal_name)}
      placeHolder={translate('VendorDeals.NewDealSearch')}
      textFieldDataTestId="gds-searchResult-searchBar-input"
    />
  );
}
